<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.departmentId" hidden/>

      <t-input v-model="form.name"  :add-error="error.name" label="Nome" required/>

      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'DepartmentForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "departmentId",
      form: {
        departmentId: 0,
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
